export const TWITTER_SITE = '@hellofixter';
export const TWITTER_CREATOR = '@fdermer';
export const FACEBOOK_URL = 'https://www.facebook.com/hellofixter';
